import PropTypes from 'prop-types';

// @mui
import { useTheme } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';

// @project
import { generateFocusVisibleStyles } from '../../utils/CommonFocusStyle';
import LogoMain from './LogoMain';
// import LogoIcon from './LogoIcon';

/***************************  MAIN - LOGO  ***************************/

interface LogoSection {
  isIcon?: Boolean,
  sx?: any,
  to?: String
}

export default function LogoSection({ isIcon, sx, to }: LogoSection) {
  const theme = useTheme();
  return (
      <ButtonBase
        disableRipple
        sx={{ ...sx, display: 'block', '&:focus-visible': generateFocusVisibleStyles(theme.palette.primary.main) }}
        aria-label="logo"
        href='/'
      >
        <LogoMain />
      </ButtonBase>
  );
}

LogoSection.propTypes = { isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.string };
